<main class="auth-page min-vh-100 bg-white text-dark">
  <div class="row g-0 min-vh-100">
    <section class="col-lg-6 auth-brand-panel text-white p-4 p-lg-4 d-none d-lg-flex flex-column justify-content-between overflow-hidden position-relative bg-dark">
      <router-link to="/" class="auth-brand-mark d-inline-flex mb-3 align-self-start bg-white rounded-3 p-2" aria-label="Siyanda Platinum home">
        <span class="auth-brand-mark-img d-block" role="img" aria-label="Siyanda Bakgatla Platinum Mine"></span>
      </router-link>

      <div>
        <p class="text-uppercase text-warning fw-bold text-xxs mb-2">Secure verification</p>
        <h1 class="h3 fw-bold mb-2">One more step to the Siyanda Platinum Platform.</h1>
        <p class="text-white-50 mb-0">
          Enter the verification code sent to your email to securely complete your sign in.
        </p>
      </div>

      <div>
        <hr class="my-3" />
        <div class="row g-3">
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Production</span>
            <span class="d-block fw-bold text-warning">Tracked daily</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Safety</span>
            <span class="d-block fw-bold text-warning">Always on</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Sustainability</span>
            <span class="d-block fw-bold text-warning">Community first</span>
          </div>
        </div>
      </div>
    </section>

    <section class="col-lg-6 bg-white text-dark d-flex align-items-center justify-content-center p-4 p-md-5">
      <div class="col-12 col-sm-10 col-md-8 col-lg-9 col-xl-7">
        <h2 class="h3 fw-bold mb-2">Check your email</h2>
        <p class="text-secondary mb-4">
          We sent a 6-digit security code to <strong>{{ email }}</strong>.
        </p>

        <SnackbarMessage
          :error-message="error_message"
          :success-message="success_message"
          @dismiss-error="error_message = ''"
          @dismiss-success="success_message = ''"
        />

        <div v-if="is_loading" class="text-center mb-3">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-secondary">Verifying code...</span>
        </div>

        <form v-if="!is_loading" @submit.prevent="submit_otp">
          <div class="d-flex justify-content-between gap-2 mb-4 otp-inputs">
            <input
              v-for="(digit,index) in otp"
              :key="index"
              v-model="otp[index]"
              maxlength="1"
              inputmode="numeric"
              :autocomplete="index === 0 ? 'one-time-code' : 'off'"
              class="form-control text-center otp-input-box w-100 min-w-0 flex-fill fs-6"
              @input="handle_input(index,$event)"
              @paste="handle_paste(index,$event)"
              @keydown.backspace="handle_backspace(index,$event)"
            />
          </div>

          <button class="btn btn-primary w-100 py-2 mb-3" :disabled="is_loading">
            Verify code
          </button>

          <p class="text-center text-secondary small mb-1">
            Didn't receive the code?
            <button type="button" class="btn btn-link text-primary fw-semibold p-0 align-baseline" @click="resend_otp" :disabled="is_loading || timer > 0">
              Resend OTP
            </button>
          </p>

          <p class="text-center text-secondary small mb-3">
            You can resend in <strong>{{ formatted_timer }}</strong>
          </p>

          <p class="text-center small mb-0">
            <router-link to="/login" class="fw-semibold text-primary">
              <i class="bi bi-arrow-left me-1"></i> Back to login
            </router-link>
          </p>
        </form>
      </div>
    </section>
  </div>
</main>
